module.exports = "<div class=more-options-title><label style=visibility:hidden><l10n>Travellers</l10n></label><div style=position:relative dropdown-kt details=adults styling=small options=::options.adults model=params.Travelers.Adult></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trains-base/templates/flights/form_options/trains-travellers-dropdown.html
// module id = 3688
// module chunks = 0